import { Address } from '@this+that/models';

export const NO_SUGGESTION_INDEX = -1;

export const SUGGESTION_DIRECTION = {
  NEXT: 1,
  PREVIOUS: -1,
} as const;

export type SuggestionDirection =
  (typeof SUGGESTION_DIRECTION)[keyof typeof SUGGESTION_DIRECTION];

export function getAlreadyAddedIndexes(
  suggestions: Address[],
  addresses: Address[],
): ReadonlySet<number> {
  const added = new Set(addresses.map((addr) => addr.value.toLowerCase()));
  const indexes = new Set<number>();
  suggestions.forEach((suggestion, index) => {
    if (added.has(suggestion.value.toLowerCase())) indexes.add(index);
  });
  return indexes;
}

export function findEnabledSuggestionIndex(
  current: number,
  direction: SuggestionDirection,
  length: number,
  disabled: ReadonlySet<number>,
): number {
  const start =
    current === NO_SUGGESTION_INDEX &&
    direction === SUGGESTION_DIRECTION.PREVIOUS
      ? length
      : current;
  for (let step = 1; step <= length; step++) {
    const candidate = (((start + direction * step) % length) + length) % length;
    if (!disabled.has(candidate)) return candidate;
  }
  return NO_SUGGESTION_INDEX;
}

export function firstEnabledSuggestionIndex(
  length: number,
  disabled: ReadonlySet<number>,
): number {
  return findEnabledSuggestionIndex(
    NO_SUGGESTION_INDEX,
    SUGGESTION_DIRECTION.NEXT,
    length,
    disabled,
  );
}
